// Configuración estática de videotutoriales remotos.
// Los MP4 y sus posters viven en Firebase Storage y se referencian por URL en
// runtime; nunca se importan como assets locales (no entran en dist/AAB).

export const VIDEO_TUTORIALS = [
  {
    id: 'video-guia-de-uso',
    title: 'Guía de uso',
    duration: '7:56',
    description: 'Visión general: clientes, gestión diaria y configuración de perfil.',
    url: 'https://firebasestorage.googleapis.com/v0/b/camperros-rutas.firebasestorage.app/o/tutorial-videos%2FRUTAPP_1%20Gu%C3%ADa%20de%20uso.mp4?alt=media&token=de6fbe4d-9a72-4587-b933-8df8e3131531',
    poster: 'https://firebasestorage.googleapis.com/v0/b/camperros-rutas.firebasestorage.app/o/tutorial-videos%2Ftutorial-posters%2Frutapp-1-guia-uso.jpg?alt=media&token=c45827ca-5966-4c26-80c9-5e6d02aa78b5',
    adminOnly: false,
    relatedTutorials: ['primeros-pasos', 'navegacion-gestion-diaria', 'perfil-accesos-apariencia'],
  },
  {
    id: 'video-funciones-administrador',
    title: 'Funciones del administrador',
    duration: '3:57',
    description: 'Configuración de perfiles, cuentas, permisos y PIN.',
    url: 'https://firebasestorage.googleapis.com/v0/b/camperros-rutas.firebasestorage.app/o/tutorial-videos%2FRUTAPP_2%20Funciones%20del%20administrador.mp4?alt=media&token=239b528e-a5ac-403d-83f7-4b6f644ad357',
    poster: 'https://firebasestorage.googleapis.com/v0/b/camperros-rutas.firebasestorage.app/o/tutorial-videos%2Ftutorial-posters%2Frutapp-2-administrador.jpg?alt=media&token=730aeaa5-6955-4740-847d-beb269fd2785',
    adminOnly: true,
    relatedTutorials: ['acciones-de-administrador'],
  },
  {
    id: 'video-comunicacion-perfiles',
    title: 'Comunicación entre perfiles',
    duration: '1:26',
    description: 'Perfiles, estados de ruta, avisos y comunicación del equipo.',
    url: 'https://firebasestorage.googleapis.com/v0/b/camperros-rutas.firebasestorage.app/o/tutorial-videos%2FRUTAPP_3%20Comunicacion%20entre%20perfiles.mp4?alt=media&token=b169c843-97bf-42ce-a0e4-3eff103d19f5',
    poster: 'https://firebasestorage.googleapis.com/v0/b/camperros-rutas.firebasestorage.app/o/tutorial-videos%2Ftutorial-posters%2Frutapp-3-comunicacion.jpg?alt=media&token=b2b3c821-f952-4967-bf68-14bc022fabe0',
    adminOnly: false,
    relatedTutorials: ['comunicacion-entre-usuarios'],
  },
  {
    id: 'video-cargar-pdf',
    title: 'Cargar PDF',
    duration: '1:51',
    description: 'Cómo preparar e importar la planificación de clientes desde un PDF.',
    url: 'https://firebasestorage.googleapis.com/v0/b/camperros-rutas.firebasestorage.app/o/tutorial-videos%2FRUTAPP_4%20Cargar%20PDF.mp4?alt=media&token=4ffc9166-ccdf-4eb3-857e-1040e1825b42',
    poster: 'https://firebasestorage.googleapis.com/v0/b/camperros-rutas.firebasestorage.app/o/tutorial-videos%2Ftutorial-posters%2Frutapp-4-cargar-pdf.jpg?alt=media&token=5ffdaa84-a746-4268-b41d-667ee2a1812f',
    adminOnly: false,
    relatedTutorials: [],
  },
];

export function getVisibleVideoTutorials(userRole) {
  const isAdmin = userRole != null && userRole !== 'worker';
  return VIDEO_TUTORIALS.filter((video) => !video.adminOnly || isAdmin);
}